import {create} from 'zustand'
import {
    LOCAL_STORAGE_ACCESS_TOKEN,
    LOCAL_STORAGE_ADMIN_TOKEN,
    LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN,
    LOCAL_STORAGE_AIRBNB_REFRESH_TOKEN,
    LOCAL_STORAGE_REFRESH_TOKEN
} from '@features/user/constants.ts'
import {User} from '@features/user/types.ts'
import {queryClient} from '@/queryClient'

type AuthStore = {
    user: Partial<User> | null
    accessToken: string | null
    refreshToken: string | null
    airbnbAccessToken: string | null
    airbnbRefreshToken: string | null
    adminAccessToken: string | null
    setTokens: (parameters: {accessToken: string; refreshToken: string | null; adminAccessToken?: string}) => void
    setAirbnbTokens: (airbnbAccessToken: string, airbnbRefreshToken: string) => void
    resetAuthTokens: () => void
    resetAirbnbTokens: () => void
    setUser: (user: Partial<User>) => void
}

export const useAuthStore = create<AuthStore>(set => ({
    user: null,
    accessToken: localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN),
    refreshToken: localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN),
    airbnbAccessToken: localStorage.getItem(LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN),
    airbnbRefreshToken: localStorage.getItem(LOCAL_STORAGE_AIRBNB_REFRESH_TOKEN),
    adminAccessToken: localStorage.getItem(LOCAL_STORAGE_ADMIN_TOKEN),
    setUser: (user: Partial<User>) => {
        set({user})
    },
    setTokens: ({accessToken, refreshToken, adminAccessToken}) => {
        set({accessToken, refreshToken, adminAccessToken})
        localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, accessToken)
        if (refreshToken) {
            localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN, refreshToken)
        }
        if (adminAccessToken) {
            localStorage.setItem(LOCAL_STORAGE_ADMIN_TOKEN, adminAccessToken)
        }
    },
    setAirbnbTokens: (airbnbAccessToken: string, airbnbRefreshToken: string) => {
        set({airbnbAccessToken, airbnbRefreshToken})
        localStorage.setItem(LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN, airbnbAccessToken)
        localStorage.setItem(LOCAL_STORAGE_AIRBNB_REFRESH_TOKEN, airbnbRefreshToken)
    },
    resetAirbnbTokens: () => {
        set({airbnbAccessToken: null, airbnbRefreshToken: null})
        localStorage.removeItem(LOCAL_STORAGE_AIRBNB_ACCESS_TOKEN)
        localStorage.removeItem(LOCAL_STORAGE_AIRBNB_REFRESH_TOKEN)
    },
    resetAuthTokens: () => {
        queryClient.clear()
        set({accessToken: null, refreshToken: null, adminAccessToken: null, user: null})
        localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN)
        localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN)
        localStorage.removeItem(LOCAL_STORAGE_ADMIN_TOKEN)
    }
}))
